import { URLS } from '../../../const/nav'
import { authFetch } from '../../../services/authFetch'

const URL = {
  technical: '',
  ophthalmologist: '',
  patient: '/pacientes/propio'
}

export const getUserData = async (role, token) => {
  try {
    if (!URL[role]) return null

    const response = await authFetch(`${URLS.BACKEND_URL + URL[role]}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${token}`
      }
    })
    if (response.ok) {
      return await response.json()
    } else {
      console.error('Error en la solicitud:', response.status, response.statusText)
      return null
    }
  } catch (error) {
    console.error('Error durante la solicitud:', error)
    return null
  }
}
